var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkAttendence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}\n\t.st1{fill:#F7DE2A;}\n\t.st2{fill:#222222;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4 6.9c0 -1.5 1.1 -2.6 2.6 -2.8 -0.3 -0.1 -0.6 -0.2 -1 -0.2 -1.5 0 -2.8 1.2 -2.8 2.7l1.5 8.6h1l-1.3 -8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m10.4 6.9 1.3 8.3h1.7l1.5 -8.6C14.8 5.4 14 4.4 13 4c-1.5 0.2 -2.6 1.4 -2.6 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9 16.4H7.2c-1.1 0 -2 0.7 -2.2 1.7h14.2c-0.4 -1 -1.3 -1.7 -2.3 -1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.7 18.1h-0.4c-0.3 -1.6 -1.7 -2.9 -3.5 -2.9h-2.3L16 6.7v-0.1c0 -0.5 -0.1 -1.1 -0.3 -1.5 -0.6 -1.4 -2 -2.4 -3.7 -2.4 -2.2 0 -4 1.8 -4 4v0.1l1.4 8.4H7.1c-1.7 0 -3.2 1.3 -3.5 2.9h-0.3c-0.3 0 -0.6 0.3 -0.6 0.6s0.3 0.6 0.6 0.6h17.4c0.3 0 0.6 -0.3 0.6 -0.6s-0.2 -0.6 -0.6 -0.6zM9.2 6.6c0 -1.5 1.3 -2.7 2.8 -2.7 0.3 0 0.7 0.1 1 0.2 1.1 0.4 1.8 1.4 1.9 2.6l-1.5 8.6h-2.7L9.2 6.6zM4.9 18.1c0.3 -1 1.2 -1.7 2.2 -1.7h9.7c1.1 0 2 0.7 2.2 1.7H4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.6 20.1H5.8c-0.3 0 -0.6 0.3 -0.6 0.6s0.3 0.6 0.6 0.6h12.8c0.3 0 0.6 -0.3 0.6 -0.6s-0.3 -0.6 -0.6 -0.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkAttendence);
export default __webpack_public_path__ + "static/media/icon_link_attendence.717a80766cdd7693e29fddf58edfbb66.svg";
export { ForwardRef as ReactComponent };